import { openAPIClient } from '../openApiClient';
import type {
  GetUserPreferencesServiceConfig,
  UpdateUserPreferencesResponse,
  UpdateUserPreferencesServiceConfig,
  UserPreferencesResponse,
} from './types';

/**
 * Gets user preferences by user ID
 * Used for loading user preferences in settings/profile views
 */
export async function getUserPreferencesService({
  httpRequestConfig,
  params,
}: GetUserPreferencesServiceConfig): Promise<UserPreferencesResponse> {
  const client = await openAPIClient(httpRequestConfig);

  if (params === undefined) {
    throw new Error('User ID is required');
  }

  const response = await client.GET('/v1/auth/userPreferences/{id}', {
    params: {
      path: {
        id: params.id,
      },
    },
  });

  if (response.error !== undefined) {
    throw new Error(response.error.message);
  }

  return response.data;
}

/**
 * Updates user preferences
 * Used in user settings/preferences forms
 */
export async function updateUserPreferencesService({
  httpRequestConfig,
  params,
}: UpdateUserPreferencesServiceConfig): Promise<UpdateUserPreferencesResponse> {
  const client = await openAPIClient(httpRequestConfig);

  if (params === undefined) {
    throw new Error('Params are required');
  }

  const response = await client.PUT('/v1/auth/userPreferences/{id}', {
    params: {
      path: {
        id: params.params.id,
      },
    },
    body: params.body,
  });

  if (response.error !== undefined) {
    throw new Error(response.error.message);
  }

  return response.data;
}
